import React, { FC, useState } from 'react';

import { Button, Input, message } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import styles from './PasswordEdit.module.scss';

const MIN_PASSWORD_LENGTH = 1;
const nameSpace = 'general.passwordEdit';

interface PasswordEditProps {
    onSave: (password: string) => Promise<void>;
    onCancel: () => void;
    isLoading: boolean;
}

const PasswordEdit: FC<PasswordEditProps> = ({
    onSave,
    onCancel,
    isLoading,
}) => {
    const { t } = useTranslation();
    const [password, setPassword] = useState<string>('');

    const isValid = password.length >= MIN_PASSWORD_LENGTH;

    const handleSubmit = (): void => {
        if (isValid) {
            onSave(password);
        }
    };

    const handleKeyUp = (e: React.KeyboardEvent): void => {
        if (e.key === 'Enter') {
            if (isValid) {
                handleSubmit();
            } else {
                message.error(t(`${nameSpace}.minLengthError`, { length: MIN_PASSWORD_LENGTH }));
            }
        }
    };

    return (
        <div className={styles['password-edit-container']}>
            <Input.Password
                className={styles['password-input']}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyUp={handleKeyUp}
                placeholder={t(`${nameSpace}.placeholder`)}
                disabled={isLoading}
                autoFocus
                autoComplete="off"
            />
            <div className={styles['action-buttons-container']}>
                <Button
                    type="link"
                    className={styles['submit-button']}
                    onClick={handleSubmit}
                    disabled={!isValid || isLoading}
                >
                    <CheckOutlined className={styles.icon} />
                </Button>
                <Button
                    type="link"
                    className={styles['close-button']}
                    onClick={onCancel}
                    disabled={isLoading}
                >
                    <CloseOutlined className={styles.icon} />
                </Button>
            </div>
        </div>
    );
};

export default PasswordEdit;

